module.exports = require("./lib/_stream_passthrough.js")



/*****************
 ** WEBPACK FOOTER
 ** ./~/node-libs-browser/~/readable-stream/passthrough.js
 ** module id = 362
 ** module chunks = 0
 **/